var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProjectsHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 112,
    viewBox: "0 0 135 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28041",
    "data-name": "Group 28041",
    transform: "translate(-766.728 -529)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13176",
    "data-name": "Rectangle 13176",
    width: 135,
    height: 112,
    rx: 10,
    transform: "translate(766.728 529)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28037",
    "data-name": "Group 28037",
    transform: "translate(396.728 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    "data-name": "Subtraction 18",
    d: "M15343.623,1123.5h-94.353a10,10,0,0,1-10-10v-92a10,10,0,0,1,10-10h115a10,10,0,0,1,10,10v63.458l-39.521-30.747-29.975-12.429-29.688,12.529,16.271,7.76-14.836,6.477,12.919,5.7-12.919,5.48,27.083,14.4,40.018,29.37Z",
    transform: "translate(-14869.271 -488.5)",
    fill: "#00aec7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28024",
    "data-name": "Group 28024",
    transform: "translate(-13.559 243.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_33823",
    "data-name": "Path 33823",
    transform: "translate(876.099 354.707) rotate(135)",
    fill: "#00aec7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.0287971496582 40.98695373535156 L 13.28925609588623 29.80693435668945 L 1.801198959350586 1.759254693984985 L 30.40176773071289 12.69419479370117 L 41.0287971496582 40.98695373535156 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.602413177490234 3.518516540527344 L 14.05463409423828 29.03724098205566 L 39.29281234741211 39.20912170410156 L 29.62398147583008 13.46742057800293 L 3.602413177490234 3.518516540527344 M -3.814697265625e-06 -3.814697265625e-06 L 31.17954635620117 11.92096710205078 L 42.76477813720703 42.76477813720703 L 12.52388763427734 30.57662582397461 L -3.814697265625e-06 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_33822",
    "data-name": "Path 33822",
    transform: "translate(876.099 342.729) rotate(135)",
    fill: "#00aec7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 41.0287971496582 40.98695373535156 L 13.28925609588623 29.80693435668945 L 1.801198959350586 1.759254693984985 L 30.40176773071289 12.69419479370117 L 41.0287971496582 40.98695373535156 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.602413177490234 3.518516540527344 L 14.05463409423828 29.03724098205566 L 39.29281234741211 39.20912170410156 L 29.62398147583008 13.46742057800293 L 3.602413177490234 3.518516540527344 M -3.814697265625e-06 -3.814697265625e-06 L 31.17954635620117 11.92096710205078 L 42.76477813720703 42.76477813720703 L 12.52388763427734 30.57662582397461 L -3.814697265625e-06 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33821",
    "data-name": "Path 33821",
    d: "M0,0,31.18,11.921,42.765,42.765,12.524,30.577Z",
    transform: "translate(876.099 328.619) rotate(135)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProjectsHover);
export default __webpack_public_path__ + "static/media/my_projects_hover.376b56d5ccd262800e7ac6e360277e2d.svg";
export { ForwardRef as ReactComponent };